<template>
  <div class="tabsPlatform-content margin-general">
    <!-- Mostrar SelectCustom y botones de tabs solo si hay más de una opción -->
    <template v-if="tabs && tabs.length > 1">
      <SelectCustom
        class="selectItem"
        :options="tabs"
        v-model="selected"
      />

      <div class="buttonsContainer" ref="buttonsContainer">
        <button
          v-for="tab in tabs"
          :key="tab.name"
          class="buttonItem"
          :class="{ selected: selected === tab.value }"
          @click="selectTab(tab.value)"
        >
          {{ $t(tab.label) }}
        </button>

        <span class="selected-border" :style="borderStyle">
          <div class="border-style"></div>
        </span>
      </div>
    </template>

    <div
      class="card-content"
      v-for="row in categories[selected] || []"
      :key="row.index"
    >
      <h3>{{ $t(row.title) }}</h3>
      <p class="body-4 descr">{{ $t(row.description) }}</p>

      <div class="content-detail">
        <div class="text">
          <p class="heading-h4">{{ $t(row.text.title) }}</p>
          <p class="body4" v-if="row.text.desc">{{ $t(row.text.desc) }}</p>
          <div class="buttons">
            <client-only>
              <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium" rel="noopener noreferrer">
                {{ $t(props.buttonLabelKey) }}
              </a>
            </client-only>
          </div>
        </div>
        <div class="detail">
          <div v-for="(opt, index) in row.details || []" class="option" :key="index">
            <div class="icon">
              <span class="material-symbols-outlined" translate="no">{{ opt.icon }}</span>
            </div>
            <div class="text-detail">
              <p class="subtitle-4 bold" v-if="opt.title">{{ $t(opt.title) }}</p>
              <p class="body-4">{{ $t(opt.description) }}</p>
            </div>
          </div>
          <div
            class="cont_list"
            v-if="(row.subtitles && row.subtitles.length) || (row.commoditiesItems && row.commoditiesItems.length)"
          >
            <div class="title" v-if="row.subtitles && row.subtitles.length">
              <div v-for="(subtitle, index) in row.subtitles" :key="index">
                <p class="body-6-bold">{{ $t(subtitle) }}</p>
              </div>
            </div>
            <div
              v-for="(group, index) in row.commoditiesItems || []"
              :key="index"
              class="list"
            >
              <div v-for="item in group" :key="item">
                <p class="body-4">{{ $t(item) }}</p>
              </div>
            </div>
          </div>
        </div>
        <client-only>
          <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="btn_mobile primary-button-medium" rel="noopener noreferrer">
            {{ $t(props.buttonLabelKey) }}
          </a>
        </client-only>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useExternalUrl } from '@/composables/useExternalUrl';

import SelectCustom from "../utils/select/SelectCustom.vue";
// import '~/assets/scss/components/forex/tabs_platform.scss';

const { getExternalUrl } = useExternalUrl();

const props = defineProps({
  tabs: Array,
  selected: String,
  categories: Object,
  buttonLabelKey: {
    type: String,
    default: "stocks.buttonTable"
  }
});

const selected = ref(props.tabs?.length > 0 ? props.tabs[0].value : '');
const selectedButtonIndex = ref(0);
const borderStyle = ref({});
const buttonsContainer = ref(null);

function selectTab(tabName) {
  const newIndex = props.tabs.findIndex((tab) => tab.value === tabName);
  if (newIndex !== -1) {
    selected.value = tabName;
  }
  selectedButtonIndex.value = newIndex;
  updateBorderBottomStyle();
}

function initializeBorderBottomStyle() {
  const button = buttonsContainer.value.children[selectedButtonIndex.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

function updateBorderBottomStyle() {
  const button = buttonsContainer.value.children[selectedButtonIndex.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

onMounted(() => {
  if (props.tabs.length > 1) {
    initializeBorderBottomStyle();
  }
  selected.value = props.tabs?.length > 0 ? props.tabs[0].value : '';
});

watch(() => props.tabs, (newTabs) => {
  if (newTabs.length > 1) {
    initializeBorderBottomStyle();
  }
  selected.value = newTabs?.length > 0 ? newTabs[0].value : '';
});
</script>
